<template>
    <div ref="notificationItem" :key="`notification-${_uid}`" class="rounded">
        <vx-scroll-trigger
            :parent="$refs.notificationItem"
            @visible="setNotificationReadStatus(item)"
        >
            <div class="notification-item" :class="{ 'old-item': item.isRead }">
                <div @click="setNavigation(item)" class="p-2">
                    <div class="flex items-center justify-center">
                        <vx-basic-icon
                            v-if="showIcon"
                            rounded
                            color="warning"
                            icon="MailIcon"
                            size="8"
                        />
                        <div class="w-full flex justify-between">
                            <div class="ml-2">
                                <h5 class="uppercase">
                                    {{ item.title }}
                                </h5>
                                <!-- <vs-chip
                                    color="danger"
                                    v-if="item.isImportant"
                                    class="new-notification-chip"
                                >
                                </vs-chip> -->
                            </div>
                            <div class=" ">
                                <small class="lighten-font italic">{{ humanizedDate }} </small>
                            </div>
                        </div>
                    </div>
                    <div class="break-words pl-2 mt-1">
                        <p class="overflow-anywhere">
                            {{ item.body }}
                        </p>
                    </div>
                </div>
                <div class="flex m-2" :class="extraClass">
                    <vx-button v-if="hasLink" color="primary" type="flat">Visit Link</vx-button>
                    <vx-button color="danger" type="flat" @click="dismissNotification(item)">
                        Dismiss
                    </vx-button>

                    <!-- <vx-action-icon
                        @click="dismissNotification(item)"
                        icon="BellOffIcon"
                        size="4"
                        class="cursor-pointer"
                        color="danger"
                    ></vx-action-icon> -->
                </div>
                <vs-divider class="my-0" />
            </div>
        </vx-scroll-trigger>
    </div>
</template>

<script>
import VxActionIcon from '../VxActionIcon.vue'
import NewNotificationItem from './NewNotificationItem.vue'
import OldNotificationItem from './OldNotificationItem.vue'
export default {
    name: 'notification-item',
    components: {
        NewNotificationItem,
        OldNotificationItem,
        VxActionIcon
    },
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        borderColor: {
            type: String,
            default: 'primary'
        },
        showIcon: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {}
    },
    computed: {
        humanizedDate() {
            var date = new Date(this.item.scheduledDate)
            return date.humanize_time_diff()
        },
        dateString() {
            var date = new Date(this.item.scheduledDate)
            return date.toDateString()
        },
        sampleImage() {
            return require('../../../assets/images/leaderboard/1st.png')
        },
        hasLink() {
            return !!this.item.link
        },
        extraClass() {
            return this.hasLink ? 'justify-between' : 'justify-center'
        }
    },
    methods: {
        setNavigation(item) {
            // if (item.isRead) {
            //     return
            // }
            // try {
            //     this.$store.dispatch('notification/setReadNotification', item.id)
            //     //do route navigation
            // } catch (err) {}
        },
        setNotificationReadStatus(notification) {
            if (!notification.isRead) {
                this.setReadStatus(notification.id)
            }
        },
        setReadStatus(id) {
            if (!id) {
                return
            }
            this.$store.dispatch('notification/setReadNotification', id)
        },
        dismissNotification(notification) {
            if (!notification) {
                return
            }
            this.$store.dispatch('notification/dismissNotification', notification.id)
        }
    }
}
</script>

<style lang="scss" scoped>
.notification-card {
    border-radius: 3%;
}
.slide-fade-enter-active {
    transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
}
.overflow-anywhere {
    overflow-wrap: anywhere;
}
.lighten-font {
    color: #626262;
}
.new-notification-chip {
    padding: 0px !important;
    min-height: 16px !important;
    min-width: 16px !important;
    max-height: 2px !important;
}
.old-item {
    background-color: rgba(40, 25, 84, 0.05);
}
</style>
